import { render, staticRenderFns } from "./GrainSpecificationsAdd.vue?vue&type=template&id=5d5522c7&scoped=true"
import script from "./GrainSpecificationsAdd.vue?vue&type=script&lang=js"
export * from "./GrainSpecificationsAdd.vue?vue&type=script&lang=js"
import style0 from "./GrainSpecificationsAdd.vue?vue&type=style&index=0&id=5d5522c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5522c7",
  null
  
)

export default component.exports